<template>
  <div>
    <p>
      <br/>
    </p>
    <p style="text-align:center">
      <span style="font-size: 19px;">中国海事仲裁委员会网上仲裁立案须知</span>
    </p>
    <p style="text-align:center">
      <strong><span style="font-size: 19px">&nbsp;</span></strong>
    </p>
    <p style="text-indent:37px">
      <span style="font-size:16px"><span style="">第一条</span> </span><span style="font-size:16px">&nbsp;</span><span style="font-size:16px"><span style="">为了以在线方式公正、高效地解决当事人约定由中国海事仲裁委员会（以下简称</span>“仲裁委员会”）受理的争议案件，依据《中华人民共和国仲裁法》<span style="">《中国海事仲裁委员会仲裁规则》（以下简称</span>“《仲裁规则》”）《<span style="">中国海事仲裁委员会网上仲裁规则</span><span style="">》</span><span style="">（以下简称</span>“《网上仲裁规则》”）等的相关规定，</span><span style="font-size:16px">结合</span><span style="font-size:16px">仲裁委员会网上仲裁</span><span style="font-size:16px">立案工作</span><span style="font-size:16px">的</span><span style="font-size:16px">实际，特制定本立案须知。</span>
    </p>
    <p style="text-indent:37px">
      <span style="font-size:16px"><span style="">第二条</span> </span><span style="font-size:16px">&nbsp;</span><span style="font-size:16px">仲裁委员会网上仲裁平台适用于解决当事人约定由仲裁委员会受理的签订或履行行为部分或全部在互联网上完成的合同争议。</span>
    </p>
    <p style="text-indent:37px">
      <span style="font-size:16px"><span style="">第三条</span> </span><span style="font-size:16px">&nbsp;&nbsp;<span style="">当事人及其他</span></span><span style="font-size:16px">仲裁</span><span style="font-size:16px">参与人应当遵循诚实信用原则，如实填写相关信息，确保提交的有关材料完整、清晰、真实。</span>
    </p>
    <p style="text-indent:37px">
      <span style="font-size:16px"><span style="">第四条</span> </span><span style="font-size:16px">&nbsp;<span style="">当事人及其他</span></span><span style="font-size:16px">仲裁</span><span style="font-size:16px">参与人使用</span><span style="font-size:16px">网上仲裁</span><span style="font-size:16px">平台实施</span><span style="font-size:16px">仲裁</span><span style="font-size:16px">行为的，应首先登录</span><span style="font-size:16px">网上仲裁平台</span><span style="font-size:16px">主页</span><span style="font-size:16px">（网址为</span><span style="font-size:16px">http</span><span style="font-size:16px">s</span><span style="font-size:16px">://www.earbitration.org.cn</span><span style="font-size:16px">）。当事人应当向仲裁委员会提交身份证明文件，包括但不限于通过证件证照比对、生物特征识别或者其他法律认可的在线方式等完成身份认证，并取得登录网上仲裁平台的专用账号。使用专用账号登录网上仲裁平台所作出的行为，视为被认证人本人行为，但因网上仲裁平台技术原因导致系统错误，或者被认证人能够证明网上仲裁平台账号被盗用的除外。</span>
    </p>
    <p style="text-indent:37px">
      <span style="font-size:16px"><span style="">第五条</span> </span><span style="font-size:16px">&nbsp;</span><span style="font-size:16px">经网上仲裁平台注册系统完成注册程序并通过身份认证的用户</span><span style="font-size:16px"><span style="">即可进行立案，通过点击</span>“</span><span style="font-size:16px">网上立案</span><span style="font-size:16px">”</span><span style="font-size:16px">，填写当事人信息等案件相关信息。</span>
    </p>
    <p style="text-indent:37px">
      <span style="font-size:16px"><span style="">第六条</span> </span><span style="font-size:16px">&nbsp;</span><span style="font-size:16px">&nbsp;<span style="">申请人</span></span><span style="font-size:16px">应提交</span><span style="font-size:16px">仲裁申请书。</span><span style="font-size:16px">可</span><span style="font-size:16px">按照网上仲裁平台填写要求在线填写仲裁申请书。</span><span style="font-size:16px">提交</span><span style="font-size:16px">仲裁申请书</span><span style="font-size:16px">后，</span><span style="font-size:16px">申请人应一并</span><span style="font-size:16px">上传</span><span style="font-size:16px">仲裁请求所依据的</span><span style="font-size:16px">证据。</span>
    </p>
    <p style="text-indent:37px">
      <span style="font-size:16px"><span style="">第七条</span> </span><span style="font-size:16px">&nbsp;</span><span style="font-size:16px">仲裁申请书</span><span style="font-size:16px">应</span><span style="font-size:16px">由申请人或申请人授权的代理人签名或盖章，并</span><span style="font-size:16px">记明下列事项：</span>
    </p>
    <p>
      <span style="font-size:16px"></span><span style="font-size:16px">　</span><span style="font-size:16px">(一) </span><span style="font-size:16px">申请人和被申请人</span><span style="font-size:16px">的</span><span style="font-size:16px">名称</span><span style="font-size:16px">、住所</span><span style="font-size:16px">及其电子送达地址</span><span style="font-size:16px">;</span>
    </p>
    <p>
      <span style="font-size:16px"></span><span style="font-size:16px">　</span><span style="font-size:16px">(二) </span><span style="font-size:16px">申请仲裁所依据的仲裁协议；</span>
    </p>
    <p>
      <span style="font-size:16px"></span><span style="font-size:16px">　</span><span style="font-size:16px">(三) </span><span style="font-size:16px">仲裁请求；</span>
    </p>
    <p>
      <span style="font-size:16px">(四)</span><span style="font-size:16px">&nbsp;<span style="">案情和争议要点</span></span><span style="font-size:16px">;</span>
    </p>
    <p>
      <span style="font-size:16px"></span><span style="font-size:16px">(五) </span><span style="font-size:16px">仲裁请求所</span><span style="font-size:16px">依据</span><span style="font-size:16px">的事实与理由</span><span style="font-size:16px">。</span>
    </p>
    <p style="text-indent:37px">
      <span style="font-size:16px"><span style="">第八条</span> </span><span style="font-size:16px">&nbsp;<span style="">确认信息无误后，</span></span><span style="font-size:16px">提交仲裁申请。</span>
    </p>
    <p style="text-indent:37px">
      <span style="font-size:16px"><span style="">第九条</span> </span><span style="font-size:16px">&nbsp;</span><span style="font-size:16px">仲裁委员会</span><span style="font-size:16px">收到</span><span style="font-size:16px">申请人的仲裁</span><span style="font-size:16px">申请材料</span><span style="font-size:16px">后，经审查</span><span style="font-size:16px">，</span><span style="font-size:16px">认为当事人的仲裁申请手续齐备</span><span style="font-size:16px">符合</span><span style="font-size:16px">受理</span><span style="font-size:16px">条件的，将通过</span><span style="font-size:16px">网上仲裁</span><span style="font-size:16px">平台向当事人发送</span><span style="font-size:16px">立案复函。</span><span style="font-size:16px">当事人</span><span style="font-size:16px">应当按照立案复函预缴仲裁费用，未预缴仲裁费用的，视为未提出仲裁申请。</span>
    </p>
    <p style="text-indent:37px">
      <span style="font-size:16px"><span style="">第十条</span> </span><span style="font-size:16px">&nbsp;</span><span style="font-size:16px">仲裁委员会经审查，认为仲裁申请手续不完备的，可以通知当事人予以补正；认为</span><span style="font-size:16px">不符合</span><span style="font-size:16px">受理</span><span style="font-size:16px">条件的</span><span style="font-size:16px">，通知当事人不予受理。</span><span style="font-size:16px">&nbsp;</span>
    </p>
    <p style="text-indent:37px">
      <span style="font-size:16px"><span style="">第十一条</span> </span><span style="font-size:16px">&nbsp;<span style="">案件</span></span><span style="font-size:16px">立案</span><span style="font-size:16px">后，</span><span style="font-size:16px">仲裁委员会将通过网上仲裁</span><span style="font-size:16px">平台</span><span style="font-size:16px">、经当事人确认的移动通信号码、传真、电子邮件或即时通讯账号等一种或多种电子方式</span><span style="font-size:16px">向</span><span style="font-size:16px">当事人</span><span style="font-size:16px">送达</span><span style="font-size:16px">仲裁</span><span style="font-size:16px">通知</span><span style="font-size:16px">、《网上仲裁规则》《仲裁规则》和《仲裁员名册》等材料。</span>
    </p>
    <p>
      <br/>
    </p>
  </div>
</template>

<script>
  export default {
    name: "guide"
  }
</script>

<style scoped>
  h4 {
    text-align: center;
    padding: 6px 0;
    font-weight: bold;
  }

  h5 {
    font-weight: bold;
    text-align: center;
    padding: 6px 0;
    font-size: 18px;
  }

  h6 {
    font-weight: bold;
    padding: 12px 0 2px;
  }

  p {
    font-size: 14px;
    text-indent: 2em;
    line-height: 28px;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/guide/components/know.vue